// App configuration
export const config = {
  api: {
    url: import.meta.env.VITE_API_URL || 'http://localhost:8787',
    wsUrl: import.meta.env.VITE_WS_URL || 'ws://localhost:8787',
  },
  cloudflare: {
    // Production URLs for Cloudflare deployment
    workerUrl: import.meta.env.VITE_WORKER_URL || '',
    pagesUrl: import.meta.env.VITE_PAGES_URL || '',
  },
  features: {
    voiceChat: import.meta.env.VITE_ENABLE_VOICE_CHAT === 'true',
    sound: import.meta.env.VITE_ENABLE_SOUND === 'true',
  },
  build: {
    version: import.meta.env.VITE_BUILD_VERSION || '1.0.0',
    environment: import.meta.env.VITE_APP_ENV || 'development',
  },
  websocket: {
    // WebSocket specific configuration for Cloudflare
    reconnectAttempts: 10,
    reconnectDelay: 1000,
    reconnectDelayMax: 5000,
    timeout: 20000,
  },
  game: {
    defaultTimeControl: {
      initial: 5 * 60 * 1000, // 5 minutes
      increment: 0,
    },
    maxMoveTime: 60 * 1000, // 1 minute per move max
    disconnectTimeout: 30 * 1000, // 30 seconds
  },
  ui: {
    animationDuration: 300,
    pieceAnimationDuration: 200,
    notificationDuration: 3000,
  },
} as const;

// Helper function to get the correct WebSocket URL based on environment
export const getWebSocketUrl = (): string => {
  return config.api.wsUrl;
};